import { NavLink, Outlet, Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const NAV = [
  { to: "/music", label: "Music", testId: "nav-music" },
  { to: "/formations", label: "Formations", testId: "nav-formations" },
  { to: "/modeling", label: "Modeling", testId: "nav-modeling" },
  { to: "/about", label: "About", testId: "nav-about" },
  { to: "/contact", label: "Contact", testId: "nav-contact" },
];

export default function Layout() {
  const location = useLocation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="relative min-h-screen text-[var(--silver)]" data-testid="layout-root">
      {/* Top nav */}
      <header
        className="fixed top-0 left-0 right-0 z-40 px-6 sm:px-10 lg:px-14 pt-7 sm:pt-9"
        data-testid="site-header"
      >
        <div className="flex items-center justify-between">
          <Link
            to="/"
            className="font-mono-wide text-[10px] sm:text-[11px] tracking-[0.45em] text-[var(--silver)] hover:text-white transition-colors"
            data-testid="brand-mark"
          >
            ALEKZ
          </Link>

          {/* Desktop nav */}
          <nav className="hidden md:flex items-center gap-10" data-testid="primary-nav">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={n.testId}
                className={({ isActive }) =>
                  `nav-link font-mono-wide text-[10px] tracking-[0.4em] ${isActive ? "active" : ""}`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>

          {/* Mobile trigger */}
          <button
            onClick={() => setOpen((v) => !v)}
            className="md:hidden font-mono-wide text-[10px] tracking-[0.4em] text-[var(--silver)]"
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {open ? "Close" : "Menu"}
          </button>
        </div>
      </header>

      {/* Mobile sheet */}
      {open && (
        <div
          className="fixed inset-0 z-30 bg-black/95 backdrop-blur-sm flex flex-col items-center justify-center gap-10 md:hidden"
          data-testid="mobile-menu"
        >
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              className="font-mono-wide text-sm tracking-[0.45em] text-[var(--silver)]"
              data-testid={`m-${n.testId}`}
            >
              {n.label}
            </NavLink>
          ))}
        </div>
      )}

      {/* Page outlet */}
      <main className="relative z-10 min-h-screen" data-testid="page-outlet">
        <Outlet />
      </main>

      {/* Footer hairline */}
      <footer
        className="relative z-10 px-6 sm:px-10 lg:px-14 pb-8 pt-12 flex items-center justify-between font-mono-wide text-[9px] tracking-[0.4em] text-[var(--silver-soft)]"
        data-testid="site-footer"
      >
        <span>© ALEKZ</span>
        <span></span>
      </footer>
    </div>
  );
}
